import { render, staticRenderFns } from "./CustomerReferenceDialog.vue?vue&type=template&id=33849f7a&scoped=true"
import script from "./CustomerReferenceDialog.vue?vue&type=script&lang=js"
export * from "./CustomerReferenceDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerReferenceDialog.vue?vue&type=style&index=0&id=33849f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33849f7a",
  null
  
)

export default component.exports